/**
* Generates a unique syncId based on staffId and timestamp
* @param {number} staffId - Staff ID
* @returns {string} - syncId in string format (staffId + timestamp in milliseconds)
*/
export const generateSyncId = (staffId) => {
    const timestamp = Date.now();
    return `${staffId}${timestamp}`;
};

/**
* Possible states for statusSync
*/
export const SYNC_STATUS = {
    SUCCESS: 'Success',
    DEADLOCK_EXCEPTION: 'DeadlockException', 
    ERROR: 'Error'
};

/**
* Checks if statusSync allows the operation to be processed
* @param {string} statusSync - Synchronization status
* @returns {boolean} - true if the operation can be processed
*/
export const canProcess = (statusSync) => {
    return statusSync === SYNC_STATUS.SUCCESS;
};

/**
* Checks if the operation should be retried
* @param {string} statusSync - Synchronization status
* @returns {boolean} - true if it should be retried
*/
export const shouldRetry = (statusSync) => {
    return statusSync === SYNC_STATUS.DEADLOCK_EXCEPTION || statusSync === SYNC_STATUS.ERROR;
};